import enumeration from "./enumeration";

const InventoryType = {
  WholeProduct: "WHOLE",
  AssembleProduct: "ASSEMBLE",
};

export default enumeration(InventoryType);
